"use client";
import type { Options as RenderOptions } from "@contentful/rich-text-react-renderer";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import type { Document } from "@contentful/rich-text-types";
import { memo, useMemo, type FC } from "react";
import type { Options } from "./richTextOptions";
import { getOptions } from "./richTextOptions";

const renderRichTextToComponent = (
    data: Document | null | undefined,
    renderOptions?: RenderOptions,
    options?: Options
) => {
    if (!data) {
        return null;
    }

    const defaultOptions = getOptions(options);
    const currentOptions = renderOptions
        ? unionOptions(defaultOptions, renderOptions)
        : defaultOptions;
    return documentToReactComponents(data as any, currentOptions);
};

export interface RichTextProps {
    data?: Document | null;
    renderOptions?: RenderOptions;
    options?: Options;
}

export const RichText: FC<RichTextProps> = memo(({ data, renderOptions, options }) => {
    const content = useMemo(
        () => renderRichTextToComponent(data, renderOptions, options),
        [data, renderOptions, options]
    );
    return <>{content}</>;
});

RichText.displayName = "RichText";

const unionOptions = (
    defaultOptions: RenderOptions,
    passedOptions: RenderOptions
): RenderOptions => {
    return {
        renderMark: { ...defaultOptions.renderMark, ...passedOptions.renderMark },
        renderNode: { ...defaultOptions.renderNode, ...passedOptions.renderNode },
        renderText: passedOptions.renderText ?? defaultOptions.renderText,
    };
};
